import PropTypes from 'prop-types';
import { HiUsers } from 'react-icons/hi2';

function formatDate(iso) {
	if (!iso) return '-';
	return new Date(iso).toLocaleDateString('de-DE', { day: '2-digit', month: 'short', year: 'numeric' });
}

/**
 * Header card for the contact list detail page: avatar + name + creation date on the left,
 * three stat columns on the right. The stats are passed in so the card looks identical
 * across tabs while showing tab-specific numbers/labels.
 */
const ContactListStatsCard = ({ list, stats }) => (
	<div className="mb-3.5 bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
		<div className="grid items-center gap-4 px-5 py-4" style={{ gridTemplateColumns: '56px 1fr auto' }}>
			{/* Avatar */}
			<div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-600 text-white flex items-center justify-center text-lg font-bold">
				<HiUsers className="w-7 h-7" />
			</div>

			{/* Title + meta */}
			<div className="min-w-0">
				<h1 className="text-lg font-bold text-text truncate">{list.name}</h1>
				<div className="flex items-center gap-1.5 flex-wrap mt-1 text-xs text-bgBase-800">
					Erstellt am {formatDate(list.createdAt)}
				</div>
			</div>

			{/* Stats */}
			<div className="flex gap-4 lg:gap-7 pl-4 lg:pl-6 border-l border-gray-200 flex-shrink-0">
				{stats.map((stat) => {
					const Icon = stat.icon;
					return (
						<div key={stat.label} className="flex flex-col gap-1 items-center">
							<span className="text-[10px] font-semibold uppercase tracking-wider text-bgBase-800">
								{stat.label}
							</span>
							<div className="flex items-center gap-1">
								{Icon && <Icon className={`w-3.5 h-3.5 ${stat.iconClass ?? 'text-bgBase-800'}`} />}
								<span className="text-lg font-bold text-text">{stat.value}</span>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	</div>
);

ContactListStatsCard.propTypes = {
	list: PropTypes.shape({
		name: PropTypes.string,
		createdAt: PropTypes.string,
	}).isRequired,
	stats: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
			icon: PropTypes.elementType,
			iconClass: PropTypes.string,
		}),
	).isRequired,
};

export default ContactListStatsCard;
